import React from 'react'
import { Reserve } from 'iconsax-react'
import { track } from '@SonarCX/lib/mixpanel'
import { IconButton, useTheme } from '@mui/material'

import Tooltip from '@SonarCX/components/atoms/Tooltip'
import ReminderModal from '@SonarCX/components/molecules/ReminderModal'

import { useAppDispatch, useAppSelector } from '@SonarCX/hooks/redux'
import { createNewReminder, selectReminder } from '@SonarCX/slices/reminder'

import useStyles from './styles'

interface ReminderNavActionProps {}

const ReminderNavAction: React.FC<ReminderNavActionProps> = () => {
  const dispatch = useAppDispatch()
  const { open, selectedReminder } = useAppSelector(selectReminder)
  const classes = useStyles()
  const theme = useTheme()

  const handleOnClick = React.useCallback(() => {
    track('NEW_REMINDER_CLICKED')
    dispatch(createNewReminder())
  }, [dispatch])

  return (
    <React.Fragment>
      <Tooltip title='New reminder' arrow>
        <IconButton
          data-testid='new-reminder'
          className={classes.root}
          onClick={handleOnClick}
        >
          <Reserve size={theme.size.lg} color='black' />
        </IconButton>
      </Tooltip>
      {open && <ReminderModal data={selectedReminder} />}
    </React.Fragment>
  )
}

export default ReminderNavAction
